import { z } from "zod";

export const ORG_MEMBERS_PAGE_SIZES = [10, 25, 50] as const;

const DEFAULT_PAGE_SIZE = 10;

export const orgMembersSearchSchema = z.object({
  limit: z
    .number()
    .int()
    .min(1)
    .max(ORG_MEMBERS_PAGE_SIZES.at(-1) ?? 50)
    .catch(DEFAULT_PAGE_SIZE)
    .default(DEFAULT_PAGE_SIZE),
  offset: z.number().int().min(0).catch(0).default(0),
});

export type OrgMembersSearch = z.infer<typeof orgMembersSearchSchema>;

export const orgMembersSearchDefaults: OrgMembersSearch = {
  limit: DEFAULT_PAGE_SIZE,
  offset: 0,
};
